import React from 'react';

const AWS_Containers = () => {
  return (
    <div>
      <h1>AWS_Containers</h1>
      <p>This is the AWS_Containers component.</p>
    </div>
  );
};

export default AWS_Containers;
